import { render, staticRenderFns } from "./save-category.vue?vue&type=template&id=c2f46112"
import script from "./save-category.vue?vue&type=script&lang=js"
export * from "./save-category.vue?vue&type=script&lang=js"
import style0 from "./save-category.vue?vue&type=style&index=0&id=c2f46112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports